import React from 'react';
import Select from "react-select";

const MonoSelect = ({
    data,
    selectArray,
    defaultValue,
    placeholder = "Sélectionner une qualification",
    noOptionsMessage = "Sélectionnez le secteur d'activité",
    ariaLabel,
}) => {

    function extract(data) {
        let options = []
        data.map((d) => {
                if(d.name){
                    options.push({value: d.name , label: d.name})
                }else{
                    options.push({value: d.IDCC_id, label: d.IDCC_name})
                }
        }
        )
        return options
    }
    const handleT = (selected) => {
        selectArray(selected)
    }
    const result = extract(data)
    
    const selectedValue = defaultValue ? result.find(opt => opt.value === defaultValue) : null

    const customStyles = {
        control: (base, state) => ({
            ...base,
            minHeight: '40px',
            height: '40px',
            borderColor: state.isFocused ? '#3b82f6' : '#E5E7EB',
            borderRadius: '0.5rem',
            borderWidth: state.isFocused ? '2px' : '1px',
            boxShadow: state.isFocused ? '0 0 0 3px rgba(59, 130, 246, 0.1)' : 'none',
            transition: 'all 0.2s ease',
            '&:hover': {
                borderColor: state.isFocused ? '#3b82f6' : '#D1D5DB',
            },
        }),
        valueContainer: (base) => ({
            ...base,
            padding: '0 12px',
            height: '40px',
        }),
        input: (base) => ({
            ...base,
            margin: 0,
            padding: 0,
            fontSize: '0.875rem',
            fontWeight: '400',
        }),
        placeholder: (base) => ({
            ...base,
            color: '#6B7280',
            fontSize: '0.875rem',
        }),
        singleValue: (base) => ({
            ...base,
            color: '#111827',
            fontSize: '0.875rem',
        }),
        menu: (base) => ({
            ...base,
            borderRadius: '0.5rem',
            border: '1px solid #E5E7EB',
            boxShadow: 'none',
            marginTop: '4px',
        }),
        menuList: (base) => ({
            ...base,
            padding: '4px',
        }),
        option: (base, state) => ({
            ...base,
            fontSize: '0.875rem',
            color: state.isSelected ? '#FFFFFF' : '#111827',
            backgroundColor: state.isSelected 
                ? '#F99600' 
                : state.isFocused 
                    ? '#fff6eb' 
                    : 'white',
            borderRadius: '0.375rem',
            padding: '8px 12px',
            margin: '2px 0',
            cursor: 'pointer',
            fontWeight: state.isSelected ? '500' : '400',
            transition: 'all 0.15s ease',
            '&:active': {
                backgroundColor: '#F99600',
                color: '#FFFFFF',
            },
        }),
        indicatorSeparator: () => ({
            display: 'none',
        }),
        dropdownIndicator: (base) => ({
            ...base,
            color: '#6B7280',
            padding: '8px',
            '&:hover': {
                color: '#374151',
            },
        }),
        clearIndicator: (base) => ({
            ...base,
            color: '#6B7280',
            padding: '8px',
            '&:hover': {
                color: '#374151',
            },
        }),
    };

    return (
        <>
            <Select
                closeMenuOnSelect={true}
                onChange={handleT}
                value={selectedValue}
                options={result}
                placeholder={placeholder}
                isClearable
                styles={customStyles}
                classNamePrefix="react-select"
                noOptionsMessage={() => noOptionsMessage}
                aria-label={ariaLabel}
            />
        </>
    );
};

export default MonoSelect;